module.exports = __webpack_public_path__ + "static/flags/MZ-7304dd4bb8da08f37c5b4b81d7431e49.gif";